import { isEqual } from 'lodash';
import { Fragment } from 'react';

import PaginationNavigation from '../pagination-navigation/pagination-navigation';

/* eslint-disable-next-line */
type PaginationProps = {
  content: Array<any>;
  currentPage: number;
  pageCount: number;
  pageLimit: number;
  onPageClick: (page: number) => void;
};

export function Pagination(props: PaginationProps) {
  const {
    content,
    currentPage,
    pageCount,
    pageLimit = 10,
    onPageClick
  } = props;

  function handlePrevious() {
    if (!isEqual(currentPage, 0)) {
      onPageClick(currentPage - 1);
    }
  }

  function handleNext() {
    if (!isEqual(currentPage, pageCount)) {
      onPageClick(currentPage + 1);
    }
  }

  const pageCountKeys = Array.from(Array(pageCount).keys());

  const paginationButtons = pageCountKeys.map((pageNumber) => (
    <button
      aria-current="page"
      className={`relative inline-flex items-center border px-4 py-2 text-caption text-MuseoSans500 font-medium ${
        isEqual(currentPage, pageNumber + 1)
          ? 'text-ghostWhite bg-footerGray border-footerGray z-20'
          : 'text-primaryGray z-10'
      }  focus:z-20`}
      key={pageNumber.toString()}
      onClick={() => onPageClick(pageNumber + 1)}
    >
      {pageNumber + 1}
    </button>
  ));

  const isPreviousDisabled = isEqual(currentPage, 1);
  const isNextDisabled = isEqual(currentPage, pageCount);

  const paginationContent =
    pageCount > 1 && content.length > pageLimit ? (
      <div className="flex items-center justify-between border-t border-gray-200 bg-white py-6">
        <div className="flex flex-1 items-center justify-between">
          <div>
            <nav
              className="isolate inline-flex -space-x-px rounded-md shadow-sm"
              aria-label="Pagination"
            >
              <PaginationNavigation
                isDisabled={isPreviousDisabled}
                position="left"
                text="Prev"
                onClick={handlePrevious}
              />

              {paginationButtons}
              <PaginationNavigation
                isDisabled={isNextDisabled}
                position="right"
                text="Next"
                onClick={handleNext}
              />
            </nav>
          </div>
        </div>
      </div>
    ) : (
      <Fragment />
    );

  return paginationContent;
}

export default Pagination;
